//The websocket URL will be different depending on your configuration. 
//For example if you are just using an IP addr it will be ws://YOURIP:8080/websocket
//If you have DNS configured it will be ws://YOURHOSTNAME:8080/websocket
export const url =  "ws://obswebrtc.com:8080/websocket";
